import { instance } from '../../config/intercepter';

export const getFaQ = async () => {
  return await instance.get('api/faqs');
};
